import React, { Fragment, useState, useEffect } from "react";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";

import { getLegalContracts, setLegalContract } from "../../../services/api/person";
import { signOut } from "../../../actions/auth";
import { showToast } from "../../../utils/helper";

import style from "./Contract.scss";

const redirectionSite = window.___APP_CONFIG___.REDIRECTION_SITE;

export const Contract = ({ toggle }) => {
  const [legalContract, setLegalContract] = useState({});
  const [contractLoading, setContractLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setContractLoading(() => true);
    getLegalContracts()
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo nuevos contratos del servidor", true);
        } else {
          if (response.LegalContractSDT.LegalContractAttachmentName) {
            setLegalContract({
              ...response.LegalContractSDT,
              LegalContractAttachmentBlob: response.blobfile,
            });
          }
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error obteniendo nuevos contratos del servidor", true);
      })
      .finally(() => {
        setContractLoading(() => false);
      });
  }, []);

  const getFile = () => {
    var a = document.createElement("A");
    a.href = `data:application/octet-stream;base64,${legalContract.LegalContractAttachmentBlob}`;
    a.download = `${legalContract.LegalContractAttachmentName}.${legalContract.LegalContractAttachmentExtension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className={style.body}>
      <div className={style.header}>
        <span className={style.title}>Antes de continuar, confirma el contrato:</span>
      </div>

      {contractLoading ? (
        <CircularProgress />
      ) : (
        <Fragment>
          <div className={style.contract}>
            <div className={style.subTitle}>Contrato de intermediación</div>
            <a onClick={getFile} className={style.attachment}>
              <i className="fa fa-file-pdf-o" />{" "}
              {legalContract && legalContract.LegalContractAttachmentName
                ? `${legalContract.LegalContractAttachmentName}.${legalContract.LegalContractAttachmentExtension}`
                : "No hay contratos disponibles."}
            </a>
            <p className={style.orangeText}>Podrás ver el contrato confirmado en la sección “Documentos”</p>
          </div>
          <span className={style.footer}>
            <Button
              className={style.button}
              onClick={() => {
                if (!legalContract || !legalContract.LegalContractAttachmentName) {
                  dispatch(signOut());
                  sessionStorage.clear();
                  window.location.href = redirectionSite;
                } else {
                  toggle("account", legalContract.LegalContractId);
                }
              }}
            >
              {!legalContract || !legalContract.LegalContractAttachmentName ? "Salir" : "confirmar"}
            </Button>
          </span>
        </Fragment>
      )}
    </div>
  );
};
